import { bootstrapInterface } from '@1x2network/duck_slot_game'
import { SLOT_LOCALISATION } from '@1x2network/legacy_localisation'
import '@pixi/math-extras'
import { CrazyTikiGame } from './CrazyTikiGame'
import { GAME_LOCALISATION } from './locale/Localisation'

const game = new CrazyTikiGame()
await game.initialise({ locale: { game: GAME_LOCALISATION } })
await game.preload()

bootstrapInterface(game, {
    enableQuickSpin: true,
    paytable: {
        '8': [SLOT_LOCALISATION.get('paytable_symbol-wild')],
        '9': [GAME_LOCALISATION.get('paytable_symbol-09-cash')],
        '10': [GAME_LOCALISATION.get('paytable_symbol-10-collector')],
        '11': [GAME_LOCALISATION.get('paytable_symbol-11-mini')],
        '12': [GAME_LOCALISATION.get('paytable_symbol-12-minor')],
        '13': [GAME_LOCALISATION.get('paytable_symbol-13-major')],
    },
})

// load the game and run it
await game.load()
game.run()
